import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { testCaseDetailed } from "../../../core/generic-templates/table-config-templates";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { MessageEnum } from "../../../core/utils/message.enum";

@Component({
  selector: "app-data-view-modal",
  standalone: true,
  imports: [CommonModule, LoadingComponent, ZorroTableComponent],
  templateUrl: "./data-view-modal.component.html",
  styleUrl: "./data-view-modal.component.scss",
})
export class DataViewModalComponent {
  @Input() data: any = [];
  @Input() projectId: any = [];
  @Input() configs: any = {};
  activeModal = inject(NgbActiveModal);
  public restService: RestService;
  isLoading: boolean = false;
  isActive: boolean = false;

  columns = testCaseDetailed;
  rows: any = [];

  constructor(restService: RestService, private toaster: ToasterService) {
    this.restService = restService;
  }

  ngOnInit() {
    console.log(this.data);
    this.configs = {
      title: "Test Case Details",
    };

    this.getData(this.projectId, this.data.tcgTestCaseResultId);
  }

  getData(projectId: any, testCaseId: any) {
    this.isLoading = true;

    this.restService.getTestCaseById(projectId, testCaseId).subscribe(
      (response) => {
        this.isLoading = false;
        console.log("Mapped Test Case", response);
        this.data = [
          {
            title: "Test Suite ID",
            content: response?.data?.key,
          },
          {
            title: "Test Case ID",
            content: response?.data?.testCaseId,
          },
          {
            title: "Test Case Description",
            content: response?.data?.testCase,
          },
          {
            title: "Story",
            content: response?.data?.storydesc,
          },
        ];
        this.rows = [
          {
            prerequisites: response?.data?.prerequisites,
            testSteps: response?.data?.testScenario,
            expectedResults: response?.data?.expectedResult
          }
        ];
      },
      (error) => {
        this.isLoading = false;
        const errorMsg = error?.message
          ? error?.message
          : MessageEnum.SOMETHING_WENT_WRONG;
        this.toaster.pop({ type: 'error', text: errorMsg });
      }
    );
  }

  isString(value: any): boolean {
    return typeof value === "string";
  }
}
